import React, { useState } from "react";
import { Button, Box } from "@mui/material";
import Alert from '@mui/material/Alert';
import GearType from "../../../components/GearType/GearType";

function OpenTripForm4({ nextStep, prevStep, handleChange, values }) {
  const [errors, setErrors] = useState({});

  const formIsValid = () => {
    const formErrors = {};

    if (!values.gearType) formErrors.gearType = "The Gear Type is required.";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const _next = (event) => {
    event.preventDefault();
    if (!formIsValid()) return;

    nextStep();
  };

  const _cancel = (event) => {
    event.preventDefault();
    prevStep();
  };

  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        m={1}
        p={1}
        bgcolor="background.paper"
      >
        <GearType gearType={values.gearType} onChange={handleChange} />
      </Box>
      {errors.gearType && <Alert severity="error">{errors.gearType}</Alert>}
      <Box display="flex" justifyContent="center" m={1} p={1}>
        <Box p={1}>
          <Button variant="contained" className="warningBtn" onClick={_cancel}>
            Back
          </Button>
        </Box>
        <Box p={1}>
          <Button variant="contained" className="successBtn" onClick={_next}>
            Continue
          </Button>
        </Box>
      </Box>
    </>
  );
}

export default OpenTripForm4;
